import { render, staticRenderFns } from "./ClientSparksModal.vue?vue&type=template&id=9b1d7bd2&scoped=true&"
import script from "./ClientSparksModal.vue?vue&type=script&lang=js&"
export * from "./ClientSparksModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientSparksModal.vue?vue&type=style&index=0&id=9b1d7bd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1d7bd2",
  null
  
)

export default component.exports